const SCRIPT_SRC = `${process.env.PUBLIC_URL}/mediaelement/mediaelement-and-player.min.js`;

const STYLESHEET_HREF = `${process.env.PUBLIC_URL}/mediaelement/mediaelementplayer.min.css`;

export type MediaElementPlayer = { remove: () => void };

type MediaElementWindow = Window & {
  MediaElementPlayer?: new (
    element: HTMLMediaElement,
    options: object
  ) => MediaElementPlayer;
};

let loading: Promise<void> | null = null;

/** Loads the MediaElement.js player stylesheet and script once per page view */
const loadMediaElement = () => {
  if ((window as MediaElementWindow).MediaElementPlayer)
    return Promise.resolve();

  if (!loading) {
    if (!document.querySelector(`link[href="${STYLESHEET_HREF}"]`)) {
      const stylesheet = document.createElement('link');

      stylesheet.rel = 'stylesheet';
      stylesheet.href = STYLESHEET_HREF;
      document.head.appendChild(stylesheet);
    }

    loading = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');

      script.src = SCRIPT_SRC;
      script.onload = () => resolve();
      script.onerror = () => {
        loading = null;
        reject();
      };
      document.body.appendChild(script);
    });
  }

  return loading;
};

/**
 * Gives each audio element MediaElement.js's player with its default options.
 * The players are passed to onReady, to be removed when the page goes.
 */
export const createAudioPlayers = (
  audios: HTMLAudioElement[],
  onReady: (players: MediaElementPlayer[]) => void
) =>
  loadMediaElement()
    .then(() => {
      const Player = (window as MediaElementWindow).MediaElementPlayer;

      if (Player) onReady(audios.map((audio) => new Player(audio, {})));
    })
    .catch(() => undefined);
